import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Divider from "@mui/material/Divider";
const Divider_Divider = (t0)=>{
    const $ = c(3);
    const { orientation } = t0;
    const t1 = "vertical" === orientation;
    let t2;
    if ($[0] !== orientation || $[1] !== t1) {
        t2 = /*#__PURE__*/ jsx(Divider, {
            className: "aqa_divider",
            "data-testid": "divider-testid",
            orientation: orientation,
            flexItem: t1
        });
        $[0] = orientation;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
export { Divider_Divider as Divider };
